import { makeSelectors } from '@utils/css';
import { postPageRouterCls } from './post-page-router.js';
import { prePageRouterCls } from './pre-page-router.js';

const pm2PlaceholderSelectors = makeSelectors({
  prePageRouter: prePageRouterCls,
  postPageRouter: postPageRouterCls
});

export { pm2PlaceholderSelectors };
//# sourceMappingURL=selectors.js.map
